<template>
  <b-container fluid>
    <expense-reload @filter-changed="updateSelectedMonth"/>
    <b-card>
        <h2 class="text-center mb-3 " >Despesas</h2>
        <b-table
          v-if="filteredExpenses.length > 0"
          :per-page="perPage"
          :current-page="currentPage"
          :items="filteredExpenses"
          striped
          hover
          responsive
          :busy="isLoading"
          class="text-center"
          :fields="tableFields"
        >
          <template v-slot:cell(gateway)="row">
            {{ (row.item.gateway.toUpperCase()) }}
          </template>
          <template v-slot:cell(quantity)="row">
            {{ formatQuantity(row.item.quantity) }}
          </template>
          <template v-slot:cell(value)="row">
            {{ formatCurrency(row.item.value) }}
          </template>
        </b-table>

        <p v-else class="text-center text-danger">
          Não há resultado para esse mês.
        </p>

        <b-pagination
          v-if="!isLoading"
          v-model="currentPage"
          :total-rows="filteredExpenses.length"
          :per-page="perPage"
          align="center"
          size="md"
          class="mt-3"
        />
     </b-card>
    <metrics />
  </b-container>
</template>

<script>
import ExpenseReload from "./ExpenseReload.vue";
import Metrics from "./Metrics.vue";
import UpdateMetrics from "./UpdateMetrics.vue"
import { BContainer, BCard,BPagination, BTable} from "bootstrap-vue";
import GatewayExpenseService from "@/service/gateway-expense"

export default {
  components: {
    ExpenseReload, Metrics, BContainer, BCard, BPagination, BTable, UpdateMetrics
  },
  data() {
    return {
      perPage: 6,
      totalRows: null,
      currentPage: 1,
      isLoading: false,
      tableFields: [
        { key: "gateway", label: "Gateway" },
        { key: "quantity", label: "Quantidade" },
        { key: "month", label: "Mês" },
        { key: "value", label: "Valor" },
      ],
      expenses: [],
      selectedMonth: null,
    };
  },
  mounted() {
    this.fetchData();
  },
 computed: {
    filteredExpenses() {
      if (!this.selectedMonth) return this.expenses;
      
      return this.expenses.filter(expense => expense.month === this.selectedMonth);
    }
  },
  methods: {
    async fetchData() {
      this.isLoading = true;

      try {
        const response = await GatewayExpenseService.getHistoric();
        const rawData = response.data || response;

        this.expenses = Object.values(rawData).map(item => ({
          gateway: item.gateway,
          quantity: item.quantity,
          month: item.month,
          value: item.value
        }));
        this.expenses = this.sortByDate(this.expenses);
         this.totalRows = this.expenses.length;
         if (this.selectedMonth) {
          this.filteredExpenses = this.expenses.filter(expense => expense.month === this.selectedMonth);
        }
        
      } catch (error) {
        console.error("Erro ao buscar histórico:", error);
      } finally {
        this.isLoading = false;
      }
    },
    updateSelectedMonth(month) {
      this.selectedMonth = month; 
      this.currentPage = 1; 
      this.fetchData(); 
    },
    formatQuantity(value) {
      return new Intl.NumberFormat('pt-BR').format(value);
    },
    formatCurrency(value) {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(value);
    }
  },
};
</script>
